import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import Dashboard from "@/pages/Dashboard";
import FileUpload from "@/pages/FileUpload";
import AnomalyResults from "@/pages/AnomalyResults";
import UserManagement from "@/pages/UserManagement";
import AuditLogs from "@/pages/AuditLogs";
import ProfileSettings from "@/pages/ProfileSettings";
import PurchaseReconciliation from "@/pages/PurchaseReconciliation";
import SalesReconciliation from "@/pages/SalesReconciliation";
import ExceptionalBalance from "@/pages/ExceptionalBalance";
import OpeningBalanceScrutiny from "@/pages/OpeningBalanceScrutiny";
import DocumentAnalyzer from "@/pages/DocumentAnalyzer";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App min-h-screen bg-gray-50">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Navigate to="/dashboard" replace />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/upload"
              element={
                <ProtectedRoute>
                  <Layout>
                    <FileUpload />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/results"
              element={
                <ProtectedRoute>
                  <Layout>
                    <AnomalyResults />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute roles={['admin']}>
                  <Layout>
                    <UserManagement />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/audit"
              element={
                <ProtectedRoute roles={['admin', 'auditor']}>
                  <Layout>
                    <AuditLogs />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ProfileSettings />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/purchase-reconciliation"
              element={
                <ProtectedRoute>
                  <Layout>
                    <PurchaseReconciliation />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/sales-reconciliation"
              element={
                <ProtectedRoute>
                  <Layout>
                    <SalesReconciliation />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/exceptional-balance"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ExceptionalBalance />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/opening-scrutiny"
              element={
                <ProtectedRoute>
                  <Layout>
                    <OpeningBalanceScrutiny />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/document-analyzer"
              element={
                <ProtectedRoute>
                  <Layout>
                    <DocumentAnalyzer />
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;